import { StartupService } from './shared/services/startup.service';
import { DialogService } from './shared/services/dialog-service';
import { StagesComponent } from './stages/stages.component';
import { AppSettings } from 'app/shared/app-settings';
import { EnrollmentProgramsService } from './shared/services/enrollment-programs.service';
import { Observable } from 'rxjs/Observable';
import { SecurityService } from './security/security.service';
import { AuthService } from './auth/auth.service';
import { LoadingSpinnerService } from './shared/services/loading-spinner.service';
import { ToastsManager } from 'ng2-toastr';
/**
 * Angular 2 decorators and services
 */
import {
  Component,
  EventEmitter,
  OnInit,
  ViewEncapsulation,
  HostBinding,
  HostListener,
  ViewContainerRef,
  ElementRef,
  ViewChild,
  Inject
} from '@angular/core';
import { AppState } from './app.service';
import { IMyOptions } from 'angular-bootstrap-md/date-picker/index';
import { RouterEvent, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, Router, ActivatedRouteSnapshot, ActivatedRoute } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material';
import { LoginAndRegisterComponent } from 'app/security/security/login-and-register/login-and-register.component';
import { ProgramStatementsModel } from 'app/shared/models/program-statements.model';
import { CardConfirmService } from './shared/services/card-confirm.service';
import { DialogComponent } from "app/shared/components/dialog/dialog.component";
import { CardDialogComponent } from "./shared/components/dialog/card-dialog.component";
import { ConfirmDialogComponent } from "app/shared/components/dialog/confirm-dialog.component";


/**
 * App Component
 * Top Level Component
 */

//navigationEnd is imported
//is navigationEnd subscribed to?

//give component access to gtag declare gtag as a function 
declare let gtag: Function; 

@Component({
  selector: 'app',
  encapsulation: ViewEncapsulation.None,
  styleUrls: [
    './app.component.css'
  ],
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  
  private isMenuOpened: boolean = false;

  spinnerColor = 'primary';
  spinnerMode = 'indeterminate';
  spinnerValue = 30;

  //todo hardcode
  get imageUrl(): Observable<string> {
    if (this.loginType)
      return this._enrollmentService.getBackgroundImageUrl(this.loginType)
    return Observable.of('');
  }
  isStagesPage: boolean = false;

  protected get appName(): string {
    return this.securityService.currentUserInfo ? this.securityService.currentUserInfo.programTitle : "Online Application";
  }

  protected get userName() {
    let user = this.securityService.currentUserInfo;
    return user ? `${user.firstName} ${user.lastName}` : null;
  }

  protected get isLogined(): boolean {
    return this.authService.isAuthenticated()
  }

  protected loginType: string;

  protected lognStatementBefore: string;

  private version:string;
  constructor(
    public appState: AppState,
    public toastr: ToastsManager,
    vcr: ViewContainerRef,
    private securityService: SecurityService,
    private authService: AuthService,
    protected loader: LoadingSpinnerService,
    private router: Router,
    private _enrollmentService: EnrollmentProgramsService,
    public dialog: MatDialog,
    public dialogService: DialogService,
    public cardConfirmService : CardConfirmService,
    public programsService: EnrollmentProgramsService,
    public activatedRoute: ActivatedRoute,
    public startupSer: StartupService

  ) {

    this.toastr.setRootViewContainerRef(vcr);
    this.startupSer.setVcr(vcr);

    this.dialogService.setComponentType(DialogComponent);
    this.dialogService.setConfirmComponentType(ConfirmDialogComponent);

    this.cardConfirmService.setConfirmComponentType(CardDialogComponent);
    

    this.loader.setAppComponentRef(vcr.element);
    this.router.events.subscribe((event: RouterEvent) => {
      this._navigationInterceptor(event); 
      this.cardConfirmService.ProgramAlias(this.loginType);
      if(event instanceof NavigationEnd)
      {
        gtag('config', 'UA-61506866-1',
      {
        'page_path': event.urlAfterRedirects
      }
      );
      }
    });

    this.version = AppSettings.AppVersion;

  }

  public ngOnInit() {
    //console.log('Init App Component', this.appState.state);
  }

  public logout() {
    this.router.navigate(["/"]).then((e)=>{
      if(e){
        this.securityService.logout().subscribe(() => {    
          this.router.navigate(["/"]);
          this.isMenuOpened = false;  
        });
      }      
    });    
  }

  profile() {
    if (this.isLogined)
      this.router.navigate(['/security/profile'])
    else
      this.router.navigate(['/']);
    this.isMenuOpened = false;
  }

  private _navigationInterceptor(event: RouterEvent): void {

    if (event instanceof NavigationStart) {
      this.loader.showSpinner();
    }
    if (event instanceof NavigationEnd) {
      this.loader.hideSpinner();
      if (this.isLogined)
        this.loginType = this.securityService.currentUserInfo.enrollmentProgramAlias;
      else
        this.loginType = this.activatedRoute.snapshot.firstChild.firstChild.params['type'];
    }
    if (event instanceof NavigationCancel) {
      this.loader.hideSpinner();
    }
    if (event instanceof NavigationError) {
      this.loader.hideSpinner();
    }
  }

  openStatementDialog() {
    this.programsService.getProgramStatements(this.loginType).subscribe((data) => {
      let html: string,
        title: string;
      if (this.isLogined) {
        html = data.loginStatementAfter,
          title = "After Login Statement";
      } else {
        html = data.loginStatementBefore,
          title = "Login Statement";
      }
      this.dialogService.openDialog(title, html);
      this.isMenuOpened = false;
    });

  }

  onActivate(e) {
    this.isStagesPage = e instanceof StagesComponent;
  }

  getCurrentYear() {
    return new Date().getFullYear();
  }
  
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts